import React from "react";
import { Link } from "react-router-dom";
import { DC_AREAS, MD_AREAS } from "../../lib/constants";

export const SEOLongform = () => {
  return (
    <section className="py-24 sm:py-32 bg-[#FAFAFA]" data-testid="seo-longform">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-[10px] uppercase tracking-[0.3em] text-brand mb-5">Your Local DC Cannabis Dispensary</div>
        <h2 className="font-serif text-5xl sm:text-6xl leading-[0.98] tracking-tight mb-10">
          District Wellness Center:<br/>Your local <em className="text-brand">D.C. cannabis dispensary</em>.
        </h2>

        <div className="prose prose-lg max-w-none text-ink-muted font-sans">
          <p className="text-lg leading-relaxed">
            At District Wellness Center (DWC), we've worked hard to become one of Washington D.C.'s most trusted
            medical cannabis dispensaries. As a locally operated brand with a flagship storefront in the city,
            our mission is simple: make finding safe, high-quality cannabis feel easy, welcoming and genuinely
            wellness-focused. From the quiet blocks of Palisades to the bustle of Capitol Hill and everywhere in
            between, we serve a wide variety of D.C. and Maryland neighborhoods with award-level service.
          </p>

          <h3 className="font-serif text-3xl text-ink mt-14 mb-6">A neighborhood dispensary in 20011.</h3>
          <p>
            District Wellness Center is proudly rooted in <strong>ZIP 20011</strong> — right on the border of
            Petworth, Brightwood, 16th Street Heights, Park View and Manor Park. If you live between Sherman
            Circle and Fort Totten, Kennedy Street and Upshur, or anywhere on upper Georgia Ave, we&rsquo;re
            your closest licensed medical cannabis dispensary. Walk-ins from 20011 are welcome every day of
            the week, and same-day delivery inside the ZIP is typically under 45 minutes.
          </p>

          <h3 className="font-serif text-3xl text-ink mt-14 mb-6">Washington D.C. Areas Served</h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-8 gap-y-2 not-prose">
            {DC_AREAS.map((a) => (
              <Link key={a.slug} to={`/areas-served#${a.slug}`} className="text-ink hover:text-brand link-underline text-base py-1.5" data-testid={`area-link-${a.slug}`}>
                {a.name}
              </Link>
            ))}
          </div>

          <h3 className="font-serif text-3xl text-ink mt-14 mb-6">Maryland Areas Served</h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-8 gap-y-2 not-prose">
            {MD_AREAS.map((a) => (
              <span key={a.slug} className="text-ink text-base py-1.5" data-testid={`md-area-${a.slug}`}>
                {a.name}
              </span>
            ))}
          </div>

          <h3 className="font-serif text-3xl text-ink mt-14 mb-6">Shop D.C.'s best cannabis selection and daily deals.</h3>
          <p>
            Step into any DWC location for the District's best curated selection of medical cannabis, including:
          </p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Fresh cannabis flower</li>
            <li>Infused edibles & gummies</li>
            <li>Soothing topicals</li>
            <li>Potent concentrates — live rosin, live resin, badder, diamonds</li>
            <li>Easy-to-use tinctures</li>
            <li>Convenient vape cartridges & disposables</li>
          </ul>
          <p>
            Check the specials section of our online menu to see what's on sale right now. Plus, our loyalty
            program rewards you for every dollar spent — redeemable on future purchases.
          </p>

          <h3 className="font-serif text-3xl text-ink mt-14 mb-6">No medical card? No problem.</h3>
          <p>
            Whether you're visiting D.C. or new to cannabis, shopping with DWC is straightforward. You can get
            on-the-spot certification for 3, 30, 90, 180, or 365-day periods — in some cases starting at as
            little as $10. Out-of-state visitors can either register as a <Link to="/faq" className="link-underline text-brand">temporary patient</Link> or
            show a valid medical cannabis ID from another U.S. state.
          </p>

          <h3 className="font-serif text-3xl text-ink mt-14 mb-6">Visiting a DWC dispensary.</h3>
          <p>
            Our DC location — <Link to="/locations" className="link-underline text-ink">DWC Uptown at 4915 Georgia Ave NW</Link> —
            is transit-accessible and a short walk from major Metro stops. We accept cash with
            on-site ATMs available, plus debit and compliant digital payment options.
          </p>

          <h3 className="font-serif text-3xl text-ink mt-14 mb-6">Enjoy same-day weed delivery in D.C.</h3>
          <p>
            Pressed for time? We offer same-day medical cannabis delivery across the District. Place your order,
            sit tight, and we'll bring it to your door — typically within the hour. Delivery windows cover
            Petworth, Columbia Heights, Shaw, Adams Morgan, Dupont Circle, Georgetown, Capitol Hill, Navy Yard,
            and beyond.
          </p>

          <h3 className="font-serif text-3xl text-ink mt-14 mb-6">Make DWC your local D.C. dispensary.</h3>
          <p>
            As one of the District's most-trusted medical cannabis retailers, it's our goal to provide the
            region's best selection of cannabis products for every need and every budget. Whether you need
            something for pain, sleep, stress, or simply to unwind — start with our <Link to="/menu" className="link-underline text-brand">live menu</Link>,
            pick pickup or delivery, and we'll take it from there.
          </p>
          <p className="italic">Have questions? Just ask. We're here to help.</p>
        </div>
      </div>
    </section>
  );
};

export default SEOLongform;
